$.validator.addMethod("gt", function (value, element, params: Array<any>) {
    let other = (params[0] as HTMLInputElement);
    let input = element as HTMLInputElement;

    value = firstDefinedValue(input.valueAsDate, input.valueAsNumber, input.value);
    let otherValue = firstDefinedValue(other.valueAsDate, other.valueAsNumber, other.value);
    
    if (value && otherValue && otherValue > value) {
        return false;
    }

    return true;
});

function firstDefinedValue(...values: any[]) {
    for (let i = 0; i < values.length; i++) {
        if (typeof values[i] !== typeof undefined && values[i] !== null) {
            return values[i];
        }
    }

    return null;
}

type JQueryUnobtrusiveAdapterCallbackParams = {
    element: HTMLElement;
    form: HTMLFormElement;
    message: string;
    params: { [name: string]: any };
    rules: { [name: string]: Array<any> },
    messages: { [name: string]: string }
}

$.validator.unobtrusive.adapters.add("gt", ["prop"], function ({ rules, messages, message, params, form }: JQueryUnobtrusiveAdapterCallbackParams) {
    rules["gt"] = [$(`[name=${$.escapeSelector(params["prop"])}]`, form)[0]];
    messages["gt"] = message;
})